import { traceCases } from "@/mocks/gossip";

const statusStyle: Record<string, string> = {
  回应中: "bg-accent-500 text-background-50",
  已辟谣: "bg-secondary-500 text-background-50",
  追踪中: "bg-primary-500 text-background-50",
};

export default function Trace() {
  return (
    <section id="trace" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="grid h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-file-list-3-line"></i>
              </span>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">当事人档案</h2>
            </div>
            <p className="mt-1.5 text-sm text-foreground-500">把一个个争议事件收进时间线，身份背景与节点全程可查</p>
          </div>
          <a href="#bbs" className="chip border border-background-200 bg-background-50 px-3.5 py-2 text-xs text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600">
            <i className="ri-notification-3-line"></i>开启事件追踪
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {traceCases.map((tc) => (
            <article key={tc.id} className="rounded-xl border border-background-200 bg-background-100/40 p-5 md:p-6">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div className="flex items-center gap-3">
                  <span className="grid h-11 w-11 items-center justify-center rounded-lg bg-foreground-950 font-heading text-lg font-bold text-accent-400">
                    {tc.name[1]}
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-bold text-foreground-950">{tc.name}</h3>
                    <span className="text-xs text-foreground-400">{tc.kind} · 事件编号 #{tc.id.toUpperCase()}</span>
                  </div>
                </div>
                <span className={`chip px-3 py-1 text-xs ${statusStyle[tc.status]}`}>
                  <i className="ri-broadcast-line"></i>{tc.status}
                </span>
              </div>

              <p className="mt-4 border-l-2 border-primary-300 pl-3 text-sm leading-relaxed text-foreground-600">
                {tc.desc}
              </p>

              <ol className="mt-5 space-y-0">
                {tc.steps.map((s, i) => (
                  <li key={`${tc.id}-${i}`} className="relative flex gap-3 pb-4 last:pb-0">
                    {i !== tc.steps.length - 1 && (
                      <span className="absolute left-[7px] top-5 h-full w-px bg-background-300"></span>
                    )}
                    <span
                      className={`mt-1 h-[15px] w-[15px] shrink-0 rounded-full border-2 ${
                        i === tc.steps.length - 1
                          ? "border-accent-500 bg-accent-500 ring-4 ring-accent-500/15"
                          : "border-background-300 bg-background-50"
                      }`}
                    ></span>
                    <div className="flex flex-1 flex-wrap items-baseline justify-between gap-x-3">
                      <span className="text-sm font-medium text-foreground-800">{s.txt}</span>
                      <span className="font-label text-[11px] text-foreground-400">{s.time}</span>
                    </div>
                  </li>
                ))}
              </ol>

              <div className="mt-5 flex items-center justify-between border-t border-dashed border-background-200 pt-4">
                <span className="flex items-center gap-1.5 text-xs text-foreground-400">
                  <i className="ri-history-line"></i>已更新至最新节点
                </span>
                <a href="#feed" className="flex items-center gap-1 text-xs text-primary-600 hover:text-primary-700">
                  查看完整档案 <i className="ri-arrow-right-s-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}